import React from "react";
import {createStore} from "redux";
import reducer from "../customizer/lib/reducer";
import ReactDOM from "react-dom";
import {Provider} from "react-redux";
import CustomLetterNecklace from "../customizer/necklace/preview";
import CustomLetterEarring from "../customizer/earring/preview";
import CustomLetterBracelet from "../customizer/bracelet/preview";
import CustomLetterCharm from "../customizer/charm/preview";
import CustomLetterRing from "../customizer/ring/preview";
import PreviewsInput from "../customizer/previews";
import UtilsComponent from "../utils/UtilsComponent";
import ErrorBoundary from "../utils/ErrorBoundary";
import {loadState} from "../customizer/lib/actions";
import {BRACELET, CHAIN, CHARM, EARRING, GOLD, NECKLACE, NECKLACELENGTH} from "../constants";

export default function render() {
    const store = createStore(reducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

    store.dispatch(loadState({
        necklaceOrientation: NECKLACE.STANDARD,
        necklaceLength: NECKLACELENGTH.LENGTH15,
        charmOrientation: CHARM.ONELINE,
        earringQuantity: EARRING.PAIR,
        braceletOrientation: BRACELET.STANDARD,
        chain: CHAIN.BEAD,
        goldColor: GOLD.YG,
        input: 'CUSTOM',
        input2: 'ABC',
        earringInput: ['ABC', 'DEF', 'GHI', 'KLM'],
        braceletLength: 7.5,
        ringSize: 9,
    }));

    ReactDOM.render(
        <Provider store={store}>
            <ErrorBoundary>
                <div className="custom-collection__input">
                    <h3>Type out and preview your nameplate&nbsp;piece:</h3>
                    <PreviewsInput/>
                </div>
                <div className="custom-collection__previews">
                    <Wrapper domNode={document.getElementById('custom-collection-necklace')}>
                        <CustomLetterNecklace/>
                    </Wrapper>
                    <Wrapper domNode={document.getElementById('custom-collection-earring')}>
                        <CustomLetterEarring/>
                    </Wrapper>
                    <Wrapper domNode={document.getElementById('custom-collection-bracelet')}>
                        <CustomLetterBracelet/>
                    </Wrapper>
                    <Wrapper domNode={document.getElementById('custom-collection-charm')}>
                        <CustomLetterCharm/>
                    </Wrapper>
                    <Wrapper domNode={document.getElementById('custom-collection-ring')}>
                        <CustomLetterRing/>
                    </Wrapper>
                    <UtilsComponent/>
                </div>
            </ErrorBoundary>
        </Provider>,
        document.getElementById('customizer')
    );
}

class Wrapper extends React.Component {
    constructor(props) {
        super(props);
        this.el = document.createElement('div');
    }

    componentDidMount() {
        this.props.domNode.appendChild(this.el);
    }

    componentWillUnmount() {
        this.props.domNode.removeChild(this.el);
    }

    render() {
        return ReactDOM.createPortal(
            this.props.children,
            this.el,
        )
    }
}
